import { SET_CUSTOMER } from "../actions/customer";

const default_state = null;

const customer = (state = default_state, action) => {
  switch (action.type) {
    case SET_CUSTOMER: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default customer;
